export enum INVESTMENT_PROGRAMME_FORM_FIELDS {
	mip_id = 'mip_id',
}

export interface InvestmentProgrammeFormValues {
	[INVESTMENT_PROGRAMME_FORM_FIELDS.mip_id]: string;
}
